import React from 'react'
import { Target, Heart, Award, Users } from 'lucide-react'

const About = () => {
  const values = [
    {
      icon: Target,
      title: 'Our Mission',
      description: 'To provide accessible, transparent banking services for everyone, empowering financial growth and security.'
    },
    {
      icon: Heart,
      title: 'Our Values',
      description: 'Trust, integrity, and customer-first service guide everything we do at UniversalTrustCU.'
    },
    {
      icon: Award,
      title: 'Our Vision',
      description: 'Leading digital banking innovation in Nigeria and beyond, making finance simple for all.'
    }
  ]

  const stats = [
    { value: '250K+', label: 'Members' },
    { value: '$50M+', label: 'Secured' },
    { value: '99.9%', label: 'Uptime' },
    { value: '24/7', label: 'Support' }
  ]

  return (
    <div>
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-blue-100 dark:from-dark-800 dark:to-dark-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            About UniversalTrustCU
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-400">
            Building financial futures through trust, innovation, and community focus since 2020.
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
              Our Story
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              UniversalTrustCU was founded with a simple mission: to provide accessible, transparent, and secure banking services to everyone. We believe that financial services should empower people, not burden them with hidden fees and complicated processes.
            </p>
            <p className="text-gray-600 dark:text-gray-400">
              Today, we serve over 250,000+ members worldwide, helping individuals and businesses achieve their financial goals through innovative digital banking solutions.
            </p>
          </div>

          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl p-8 text-white">
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-4xl font-bold mb-2">{stat.value}</div>
                  <div className="text-blue-100">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {values.map((item, index) => (
            <div key={index} className="card text-center">
              <div className="w-14 h-14 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <item.icon className="w-7 h-7 text-blue-600 dark:text-blue-400" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                {item.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Team Section */}
        <div className="mt-20 text-center">
          <Users className="w-16 h-16 text-blue-600 dark:text-blue-400 mx-auto mb-6" />
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            Our Team
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
            We're a dedicated team of financial experts, technologists, and customer service professionals committed to making banking better for everyone.
          </p>
        </div>
      </section>
    </div>
  )
}

export default About